import api from '@pray/shared/utils/api/api';
import type { CursorInfiniteQueryParams } from '@pray/shared/utils/api/types/fetch';

import type { GetSegmentsResponse } from './data/response';

type GetSegmentsProps = {
  artistId: string;
  lastItemIdentifier?: string;
  search?: string;
  sortDirection?: 'asc' | 'desc';
};

export async function getSegments({
  artistId,
  lastItemIdentifier,
  search = '',
  sortDirection = 'asc',
}: GetSegmentsProps) {
  if (!artistId) throw new Error('Artist ID is required');

  const params: CursorInfiniteQueryParams = {};

  if (search) {
    params.search = search;
  }

  if (lastItemIdentifier) {
    params.last_item_identifier = lastItemIdentifier;
  }

  if (sortDirection) {
    params.sort_direction = sortDirection;
  }

  const url = `/web/studio/artists/${artistId}/lead-segments`;
  const response = await api.executeGetRequest<GetSegmentsResponse>(url, params);

  return response.data;
}
